import { clsx } from 'clsx'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { RefObject, SyntheticEvent, useState } from 'react'
import { InferenceData } from 'type/inference'
import css from './Video.module.scss'

type Props = {
  inference: InferenceData
  onGood?: (good: boolean) => void
  onSize?: (width: number, height: number) => void
  videoRef: RefObject<HTMLVideoElement>
}

export const Video = observer(({ inference, onGood, onSize, videoRef }: Props) => {
  const video = inference.video
  const [good, setGood] = useState(false)
  const className = clsx(css.video, good && css.good)

  const onLoad = useLatestCallback((event: SyntheticEvent<HTMLVideoElement>) => {
    const { videoWidth, videoHeight } = event.currentTarget
    setGood(true)
    onGood?.(true)
    onSize?.(videoWidth, videoHeight)
  })

  const onError = useLatestCallback(() => {
    setGood(false)
    onGood?.(false)
  })

  return <video ref={videoRef} className={className} muted autoPlay={false} playsInline
    onLoadedData={onLoad} onError={onError}>
    <source src={video} />
  </video>
})
